import { DescriptionIcon } from "@l2r-front/l2r-icons"

import { L2rAppDocument } from "../app"
import { getModulesBreadcrumb } from "../utils/getModulesBreadcrumb"

import { I18N_NAMESPACE } from "./i18n"
import { API_MODULE_DOCUMENT, APP_DOCUMENT, MODULE_DOCUMENTS } from "./modules"

export const appDocument = {
    index: 100,
    color: "primary",
    component: <L2rAppDocument />,
    externalContexts: [],
    i18nNamespace: I18N_NAMESPACE,
    modules: {
        documents: {
            index: 0,
            id: API_MODULE_DOCUMENT,
            icon: DescriptionIcon,
            label: "app.modules.documents",
            path: MODULE_DOCUMENTS,
            getModulesBreadcrumb,
        },
    },
    path: APP_DOCUMENT,
    innerPathCleaner: (path) => {
        return path.replace(/attached\/[^/]+/, "")
    },
}